<template>
	<div class="feedback_box">
		<div class="w-100 text-center" style="display: flex; justify-content: center; align-items: center; height: 6%;">
			<div class="feedback_title">
				ОТЗЫВЫ
			</div>
		</div>
		<div class="feedback_card_box">
			<div class="shadow_left"></div>
			<carousel v-if="screenWidth <= 575"
				:per-page="1"
				:mouse-drag="true"
				:navigationEnabled="false"
			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
								<img :src="star.img" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<carousel v-else-if="screenWidth > 575 && screenWidth < 768"
				:per-page="2.5"
				:mouse-drag="true"
				:navigationEnabled="false"
				:scrollPerPage="false"
				:paginationEnabled="false"

			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
								<img :src="star.img" style="object-fit: cover; width: 100%; height: auto;" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<carousel v-else-if="screenWidth > 767"
				:per-page="4.5"
				:mouse-drag="true"
				:navigationEnabled="false"
				:scrollPerPage="false"
				:paginationEnabled="false"

			>
				<slide  :key="idx" v-for="(star, idx) in stars" style="padding: 0.5em;">
					<div class="star_card">
						<div class="star_card_img">
								<img :src="star.img" alt=""/>
						</div>
						<div class="star_card_name">
							{{star.name}}
						</div>
						<div class="star_card_text">
							{{star.text}}
						</div>
					</div>
				</slide>
			</carousel>
			<div class="shadow_right"></div>
		</div>
	</div>
</template>

<script>
export default {
	name: "FeedbackComponent",
	data() {
		return {
			stars: [
				{
					id: 1,
					name: '',
					img: require('../assets/img/feenback_avatars/1.png'),
					text: 'Не первый раз в этом отеле. Очень хороший банный комплекс. Нравится всем. И взрослым и детям. Соляная пещера, сауны, хамамы... Молодцы! Возможность поплавать с дельфином оставила ПРЕКРАСНЫЕ впечатления у всей семьи! Вкусная еда в новом ресторане. Спасибо персоналу!'
				},
				{
					id: 2,
					name: '',
					img: require('../assets/img/feenback_avatars/2.png'),
					text: 'Отличный отель для отдыха с детьми! Постоянный уличный бассейн 2м глубина, 34град, ооочень теплый, детские площадки и игровые комнаты. Номера небольшие и уютные. Завтрак вкусный: омлет, запеканка, блинчики и многое другое. До Ярославля центра 40 мин на машине. ОБЯЗАТЕЛЬНО К посещению шоу белух!!! Точно вернемся!'
				},
				{
					id: 3,
					name: '',
					img: require('../assets/img/feenback_avatars/3.png'),
					text: 'Очень понравились выходные в этом отеле. Приятные ребята работают в спа. Александр массажист просто волшебник. Уход тоже очень нам понравился. Вкусно готовят в ресторане. Из минусов — высокая загрузка утром на завтраке и отсутствие уборки в номере. Под впечатлением от шоу и плавания с дельфинами очень понравилось. Теперь приедем сюда.'
				},
				{
					id: 4,
					name: '',
					img: require('../assets/img/feenback_avatars/4.png'),
					text: 'Замечательный отель! Мы жили в капсульном домике с проектором и системой умный дом и остались в восторге от поездки! Открытый подогреваемый бассейн, Спа с множеством саун и хаммамов, вкусные завтраки, шоу с морскими животными — изюминка отеля! Недалеко много красивых городов. Хочется вернуться и повторить такой чудесный отдых! Спасибо!'
				},
				{
					id: 5,
					name: '',
					img: require('../assets/img/feenback_avatars/5.png'),
					text: 'Очень понравилось. Ездили с детьми с ночёвкой и на шоу-программу. Дети в восторге, не хотели уезжать. Номер был очень комфортный. Еда отличная. Отношение и сервис тоже очень понравились. Очень уютная обстановка и атмосфера. На улице подогреваемый бассейн. В -3 было очень комфортно. Есть спа, сауна. Детская комната. Обязательно приедем летом.'
				},
			]
		}
	},
	computed: {
		screenWidth() {
			return this.$store.state.screenWidth;
		}
	},
}
</script>

<style scoped>
.feedback_box {
	position: relative;
	background-color: #F7F3ED;
	min-height: 60vh;
	width: 100%;
}

.feedback_title {
	color: #2C3333;
	position: absolute;
	top: 0;
	margin: 0 auto;
	font-weight: 400;
	letter-spacing: 0.2em;
	font-size: 3em;
	padding: 0.5em 2em;
	width: 60%;
	background-color: #F7F3ED;
	border-radius: 10px 10px;
	padding-bottom: 4em;
}
.feedback_card_box {
	width: 100%;
	overflow: hidden;
	display: flex;
    flex-flow: row nowrap;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    margin: 5em 0;
	position: relative;

}

.star_card {
	background-color: #F7F3ED;
	padding: 1em;
	color: #333333;
	font-weight: 400;
	border-radius: 10px;
}

.star_card_img {
	border-radius: 1000px;
	overflow: hidden;
	width: 70px;
	height: 70px;
}

.star_card_img img {
	width: 70px;
	height: 70px;
	object-fit: cover;
}

.star_card_name {
	padding: 1em 0em;
}
.star_card_text {
	font-size: 0.7em;
}


.feedback_card_box > div {
	width: 100%;
}

.feedback_card_box > article {
	margin: 1em;

}


.shadow_left {
	position: absolute;
	width: 10% !important;
	left: 0;
	height: 100%;
	background: transparent;
	z-index: 10;
}
.shadow_right {
	position: absolute;
	width: 10% !important;
	right: 0;
	height: 100%;
	background: transparent;
	z-index: 10;
}

@media (max-width: 575px) {
	.feedback_title {
		color: #2C3333;
		position: relative;
		top: 0;
		margin: 0 auto;
		font-weight: 400;
		letter-spacing: 0.2em;
		font-size: 2em;
		background-color: transparent;
		border-radius: 10px 10px;
		padding: 0;
	}
	.star_card {
		background-color: #F7F3ED;
		padding: 2em;
		color: #333333;
		font-weight: 400;
		border-radius: 10px;
		width: 90%;
		margin: 0 auto;
	}
	.feedback_box {
		padding-bottom: 3em;
	}
	.star_card_name {
		font-size: 1.2em;
	}
	.star_card_text {
		font-size: 0.9em;
	}
}

</style>